import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { QueryVal } from 'Helpers/Query';
import { useLocation } from 'react-router';
import fr from 'facet-rest';
import MetaCollectionFormDrawer from '../../UI/Meta/MetaForm/MetaCollectionFormDrawer';
import useCollection from '../../../Hooks/useCollection';
import { displayErrorMessage } from '../../../Helpers/FacetNotificationManager';
import { removeQuery } from '../../../Helpers/Query';
import closeModal from '../../../Helpers/ModalHelper';
import DependentsOverride from '../../../Overrides/Dependents';

const styles = () => ({
  root: {},
});

const DependentModal = ({
  className,
  classes,
}) => {
  const { collection, setCollection } = useCollection();
  const location = useLocation();
  const link = QueryVal('dependentsLink');

  const fetchData = async () => {
    if (link) {
      try {
        const coll = fr.collection(await fr.http.Get(link), DependentsOverride);
        if (coll.resources().length() === 0) {
          throw new Error('Fetching tasks did not return any dependents.');
        }

        setCollection(coll);
      } catch (e) {
        displayErrorMessage(e, 'Could not fetch dependents');
      }
    }
  };

  const handleCloseModal = () => {
    removeQuery('modal');
    removeQuery('dependentsLink');
    closeModal();
  };

  useEffect(() => {
    fetchData();
  }, [location.search]);


  return (
    <MetaCollectionFormDrawer
      open
      className={classNames(classes.root, className)}
      anchor="right"
      collection={collection}
      loading={!collection}
      onClose={handleCloseModal}
      FormProps={{
        noIndividualSubmitButtons: true,
        rows: [['firstName', 'lastName', 'birthdate']],
      }}
    />
  );
};

DependentModal.defaultProps = {
  className: '',
};

DependentModal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DependentModal);
